import {RecommendedActionsPreview} from '@dms/features/interest-recommendations';
import {interestRoutes} from '@dms/routes';

import {useNavigate} from 'shared/web';

import {DashboardTileSize} from '../types/DashboardTileSize';

interface RecommendedActionsProps {
  size: DashboardTileSize;
}

const RECOMMENDED_ACTIONS_LIMIT_BY_SIZE: Record<DashboardTileSize, 3 | 4 | 8> = {
  quarter: 4,
  half: 4,
  tall: 8,
  wide: 3,
  large: 3,
};

export function RecommendedActions(props: RecommendedActionsProps) {
  const navigate = useNavigate();

  return (
    <RecommendedActionsPreview
      limit={RECOMMENDED_ACTIONS_LIMIT_BY_SIZE[props.size]}
      isWide={props.size === 'wide' || props.size === 'large'}
      onViewAll={() => navigate(interestRoutes.myDay)}
    />
  );
}
